import { useState, useEffect } from 'react';

import StyledWrapper from './style';

import { getTimeRemaining, twoDatesPercentage } from '../../../utils/dateUtils';

const ProgressBar = ({ data, testTitle }) => {
	const [progressPercentage, setProgressPercentage] = useState(100);
	const [lowRemainingTime, setLowRemainingTime] = useState(30);
	const [timeRemaining, setTimeRemaining] = useState('');

	const formatDateRange = (start, end) =>
		[start, end].map((date) => date?.toLocaleDateString('en-US')).join(' - ');

	const getDatesPercentage = () => {
		const startDate = data?.startDate;
		const endDate = data?.endDate;

		const percentage = twoDatesPercentage(endDate, startDate);
		setProgressPercentage(percentage);
	};

	const getCountdownPercentage = () => {
		const endDate = new Date(data?.endDate).valueOf();
		const { days, timeRemaining } = getTimeRemaining(endDate);

		days < 20 && setLowRemainingTime(15);
		days < 10 && setLowRemainingTime(5);
		setTimeRemaining(timeRemaining);
	};

	useEffect(() => {
		if (data?.startDate && data?.endDate) {
			data?.isCountdown && getCountdownPercentage();
			getDatesPercentage();
		}
	}, [data]);

	let reviewProgress;

	if (data?.isExpired) {
		reviewProgress = 0;
	} else if (data?.isUnavailable) {
		reviewProgress = 100;
	} else {
		reviewProgress = Math.floor(progressPercentage);
	}

	return (
		<StyledWrapper.OutermostContainer data-testid={`progressBar-${testTitle}-container`}>
			<StyledWrapper.TextContainer
				data-testid={`progressBar-${testTitle}-text-container`}
				isCountdown={data?.isCountdown}
			>
				{data?.isCountdown ? (
					data?.isExpired ? (
						'expired'
					) : data?.isUnavailable ? (
						'unavailable'
					) : (
						timeRemaining
					)
				) : (
					<StyledWrapper.Text data-testid={`progressBar-${testTitle}-text-1`}>
						{formatDateRange(data?.startDate, data?.endDate)}
					</StyledWrapper.Text>
				)}
			</StyledWrapper.TextContainer>

			<StyledWrapper.BarContainer data-testid={`progressBar-${testTitle}-bar`}>
				{data?.isForReview ? (
					<StyledWrapper.ReviewProgressIndicator
						data-testid={`progressBar-${testTitle}-indicator`}
						isCountdown={data?.isCountdown}
						progress={reviewProgress}
						lowRemainingTime={lowRemainingTime}
						isUnavailable={data?.isUnavailable}
						isExpired={data?.isExpired}
					/>
				) : (
					<StyledWrapper.ProgressIndicator
						data-testid={`progressBar-${testTitle}-indicator`}
						isCountdown={data?.isCountdown}
						progress={Math.floor(progressPercentage)}
						lowRemainingTime={lowRemainingTime}
					/>
				)}
			</StyledWrapper.BarContainer>
		</StyledWrapper.OutermostContainer>
	);
};

export default ProgressBar;
